/**
 * LUT 处理相关的常量字符串
 */

/** 警告：无蒙版数据 */
export const WARNING_NO_MASK_DATA = '⚠️ 无蒙版数据'

/** 日志：应用蒙版 */
export const LOG_APPLYING_MASK = '🎭 应用蒙版:'
